import { FormSetting } from '@/form-settings/form-setting';
import { BrandModel } from '@/models/tables/brand.model';
import { EsclusioneGrandiAcquirentiModel } from '@/models/tables/ms-discount-model';

export class MSDiscountFormSetting extends FormSetting {
  protected static classToCall: string;

  public static setClassToCall(classes) {
    this.classToCall = classes;

    return this;
  }

  public static getMeta(): Array<any> {
    return [
      {
        rows: [
          {
            classToUse: this.classToCall,
            key: 'id',
            controlType: 'hidden',
            order: 1,
          },
        ],
      },
      {
        rows: [
          {
            classToUse: this.classToCall,
            key: 'anno',
            controlType: 'yearDate',
            label: 'Anno',
            order: 1,
            class: 'lg:w-4/12 w-full',
            required: true,
          },
          {
            classToUse: this.classToCall,
            key: 'mese',
            controlType: 'monthDate',
            label: 'Mese',
            order: 1,
            class: 'lg:w-4/12 w-full',
            required: true,
          },
          {
            classToUse: this.classToCall,
            key: 'trimestre',
            label: 'Trimestre',
            order: 1,
            compareFn: (o1: string, o2: string) => o1 === o2,
            class: 'lg:w-4/12 w-full',
            controlType: 'dropdown',
            options: [
              { key: 'I', value: 'I' },
              { key: 'II', value: 'II' },
              { key: 'III', value: 'III' },
              { key: 'IV', value: 'IV' },
            ],
          },
          {
            classToUse: this.classToCall,
            key: 'marca',
            controlType: 'dropdown',
            compareFn: (o1: BrandModel, o2: BrandModel) => o1?.id === o2?.id,
            label: 'Marca',
            order: 1,
            class: 'lg:w-4/12 w-full',
            required: true,
            options: this.data['brands'] ?? [],
          },
          {
            classToUse: this.classToCall,
            key: 'tipo',
            label: 'Tipo',
            order: 1,
            compareFn: (o1: string, o2: string) => o1 === o2,
            class: 'lg:w-4/12 w-full',
            controlType: 'dropdown',
            options: [
              { key: 'RETAIL', value: 'RETAIL' },
              { key: 'NLT', value: 'NLT' },
            ],
          },
          {
            classToUse: this.classToCall,
            key: 'codiceMs',
            controlType: 'textinput',
            label: 'Codice MS',
            order: 1,
            class: 'lg:w-4/12 w-full',
            required: true,
          },
          {
            classToUse: this.classToCall,
            key: 'descrizioneMs',
            controlType: 'textinput',
            label: 'Descrizione MS',
            order: 1,
            class: 'lg:w-4/12 w-full',
            required: true,
          },
        ],
      },
      {
        rows: [
          {
            classToUse: this.classToCall,
            key: 'classificazioneMs',
            label: 'Classificazione MS',
            order: 1,
            required: true,
            compareFn: (o1: string, o2: string) => o1 === o2,
            class: 'lg:w-4/12 w-full',
            controlType: 'dropdown',
            options: [
              { key: 'MENSILE', value: 'MENSILE' },
              { key: 'TRIMESTRALE', value: 'TRIMESTRALE' },
              { key: 'SEMESTRALE', value: 'SEMESTRALE' },
              { key: 'EXTRA', value: 'EXTRA' },
            ],
          },
          {
            classToUse: this.classToCall,
            key: 'tipologiaMs',
            controlType: 'dropdown',
            label: 'Tipologia MS',
            order: 1,
            class: 'lg:w-4/12 w-full',
            required: true,
            compareFn: (o1: string, o2: string) => o1 === o2,
            options: [
              { key: 'Qualitativo', value: 'Qualitativo' },
              { key: 'Quantitativo', value: 'Quantitativo' },
            ],
          },
          {
            classToUse: this.classToCall,
            key: 'fascia',
            controlType: 'dropdown',
            label: 'Fascia',
            order: 1,
            class: 'lg:w-4/12 w-full',
            required: true,
            compareFn: (o1: string, o2: string) => o1 === o2,
            options: [
              { key: 'Fascia 1', value: 'Fascia 1' },
              { key: 'Fascia 2', value: 'Fascia 2' },
              { key: 'Fascia 3', value: 'Fascia 3' },
              { key: 'Fascia 4', value: 'Fascia 4' },
              { key: 'Fascia 5', value: 'Fascia 5' },
              { key: 'Nessuna Fascia', value: 'Nessuna Fascia' },
            ],
          },
          {
            classToUse: this.classToCall,
            key: 'descRaggiungimentoObiettivo',
            controlType: 'textinput',
            label: 'Desc. Raggiungimento Obiettivo',
            order: 1,
            class: 'lg:w-4/12 w-full',
            required: true,
          },
          {
            classToUse: this.classToCall,
            key: 'percMsPrevista',
            controlType: 'number',
            label: '% MS Prevista',
            order: 1,
            class: 'lg:w-4/12 w-full',
            required: true,
          },
          {
            classToUse: this.classToCall,
            key: 'percObiettivo',
            controlType: 'number',
            label: '% Obiettivo',
            order: 1,
            class: 'lg:w-4/12 w-full',
            required: true,
          },
          {
            classToUse: this.classToCall,
            key: 'obiettivoRaggiunto',
            controlType: 'slide-toggle',
            label: 'Obiettivo Raggiunto',
            order: 1,
            default: false,
            class: 'lg:w-2/12 w-full',
            required: true,
          },
          {
            classToUse: this.classToCall,
            key: 'posizioneRanking',
            controlType: 'textinput',
            label: 'Posizione Ranking',
            order: 1,
            class: 'lg:w-5/12 w-full',
          },
          {
            classToUse: this.classToCall,
            key: 'esclusioneGrandiAcquirenti',
            controlType: 'multiselect',
            compareFn: (o1: EsclusioneGrandiAcquirentiModel, o2: EsclusioneGrandiAcquirentiModel) =>
              o1?.id === o2?.id,
            label: 'Esclusione Grandi Acquirenti',
            order: 1,
            class: 'lg:w-5/12 w-full',
            required: false,
            options: this.data['bigBuyers'] ?? [],
            customAction: 'onGrandiAcquirentiChange',
          },
          {
            classToUse: this.classToCall,
            key: 'esclusioneGrandiAcquirentiLista',
            controlType: 'grandi-acquirenti-list',
            label: 'Esclusione Grandi Acquirenti Selezionati',
            order: 1,
            class: 'lg:w-full w-full',
          },
        ],
      },
    ];
  }
}
